import script from "./loading.vue?vue&type=script&setup=true&lang=ts"
export * from "./loading.vue?vue&type=script&setup=true&lang=ts"

import "./loading.vue?vue&type=style&index=0&id=29bd8e71&scoped=true&lang=scss"

import exportComponent from "D:\\NewLODAPC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29bd8e71"]])

export default __exports__